export class LegalNoticeService {
    constructor($http, apexApiUrl) {
        'ngInject'
        this.$http = $http
        this.apexApiUrl = apexApiUrl
    }

    /**
     * Retrieve a list of all legal notices.
     */
    retrieveLegalNotices(query) {
        return this.$http.get(this.apexApiUrl + "legal-notices/", {
            params: query,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Acknowledge legal notice content
     */
    acknowledgeLegalNoticeContent(legalNoticeID, legalNoticeContentID) {
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "legal-notices/" + legalNoticeID + "/acknowledge/" + legalNoticeContentID,
            headers: {
                "Content-Type": "application/json"
            }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Create a new legal notice.
     */
    createLegalNotice(notice) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "legal-notices/",
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(notice)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Update the legal notice with the given ID.
     */
    updateLegalNotice(legalNoticeID, notice) {
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "legal-notices/" + legalNoticeID,
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(notice)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Delete the legal notice with the given ID.
    */
    deleteLegalNotice(legalNoticeID) {
        return this.$http({
            method: "DELETE",
            url: this.apexApiUrl + "legal-notices/" + legalNoticeID,
            headers: {
                "Content-Type": "application/json"
            }
        }).then(function (response) {
            return response.data;
        });
    }

}
